import { render } from "./DragAndDropOrResizeEventErrorModal.vue?vue&type=template&id=5b0d166f"
import script from "./DragAndDropOrResizeEventErrorModal.vue?vue&type=script&lang=js"
export * from "./DragAndDropOrResizeEventErrorModal.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__